module.exports = __webpack_public_path__ + "static/media/step4_lender.eb21d793.png";